import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './Home';
import Categories from './Categories';
import TopCoupons from './TopCoupons';
import BestOffers from './BestOffers';
import Header from './Components/Header';
import Footer from './Components/Footer/Footer';
import Gotop from './Components/Gotop';
import WhatsApp from './Components/WhatsApp';
import ScrollToTop from './Components/ScrollToTop';
import FAQs from './Components/Footer/FAQs';
import ContactUs from './Components/Footer/Contactus';
import AboutUs from './Components/Footer/AboutUs';
import Careers from './Components/Footer/Careers';
import TermsService from './Components/Footer/TermsOfService';
import PrivacyPolicy from './Components/Footer/PrivacyPolicy';
import AdminDashBoard from './AdminDashBoard';
import UserDashboard from './UserDashboard';
import Dashboard from './Components/Dashboard';
import Popularity1 from './Components/Categories/Popularity1';
import Payment from './Components/AdminDashBoard/Payment';
import HomeRefaral from './HomeRefaral';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserPayment from './UserPayment';
import MerchantSite from './Components/MerchantSite/MerchantSite';
import MerchantPage from './Components/MerchantPage/MerchantPage';
import OwnesiteUrl from './Components/MerchantPage/OwnesiteUrl';
import Permission from './Components/MerchantPage/Permission';
import UserProductPayment from './Components/UserProductPayment';
import MerchantRegistration from './Components/MerchantRegistration';
import UserRegistration from './Components/UserRegistration';
import MerchantRefaral from './Components/MerchantRefaral';
import MerchantSignup from './Components/Registration/MerchantSignup';
import MerchantSignin from './Components/Registration/MerchantSignin';
import UserSignUp from './Components/Registration/UserSignUp';
import UserSignIn from './Components/Registration/UserSignIn';
import MerchantTermsOfServices from './Components/Footer/MerchantTermsOfServices';
import ExecutiveTermsOfServices from './Components/Executive/ExecutiveTermsOfServices';
import ExecutiveLogin from './Components/Executive/ExecutiveLogin';
import ExecutiveRegistration from './Components/Executive/ExecutiveRegistration';
// import ExcutiveDashboard from './Components/Executive/ExcutiveDashboard';
import ExcutiveReferal from './Components/Executive/ExcutiveReferal';
import ExecutiveTandS from './Components/Executive/ExecutiveTandS';
import MerchantTandS from './Components/Footer/MerchantTandS';
import UserTremsOfServices from './Components/Footer/UserTremsOfServices';
import ExcutiveProfile from './Components/Executive/ExcutiveProfile';
import ExecutiveHierarchy from './Components/Executive/ExecutiveHierarchy';
import ExcutiveDashboard from './Components/Executive/ExcutiveDashboard';
import ExecutiveDashboardOne from './Components/Executive/ExecutiveDashboardOne';
import ExecutiveRegistrationUpdate from './Components/Executive/ExecutiveRegistrationUpdate';
import MerchantForgotPassword from './Components/Registration/MerchantForgotPassword';
import MerchantResetPassword from './Components/Registration/MerchantResetPassword';
import UserForgotPassword from './Components/Registration/UserForgotPassword';
import UserResetPassword from './Components/Registration/UserResetPassword';
import ExecutiveForgotPassword from './Components/Executive/ExecutiveForgotPassword';
import ExecutiveResetPassword from './Components/Executive/ExecutiveResetPassword';
import MerchantAccountDetails from './Components/MerchantAccountDetails';
import SelectSlot from './Components/SelectSlot';
import PremiumCouponApproval from './Components/AdminDashBoard/PremiumCouponApproval';

function App() {
  const location = useLocation();

  // Define all static routes
  const staticRoutes = [
    '/',
    '/categories',
    '/top-coupons',
    '/best-offers',
    '/faqs',
    '/contactus',
    '/aboutus',
    '/careers',
    '/terms-service',
    '/privacypolicy',
    '/admin-dashboard',
    '/user/dashboard',
    '/merchant/dashboard',
    '/popular',
    '/payment',
    '/payment/:amount/:mobile',
    '/merchantpage',
    '/ownesite',
    "/permission",
    "/payment/:amount",
    "/merchantRegistration",
    "/userRegistration",
    "/merchant/refer",
    '/MerchantSignup',
    '/MerchantSignin',
    '/MerchantSignup/:id',
    '/userSignup',
    '/userSignup/:id',
    '/UserSignin',
    '/merchantterms-service',
    '/executiveTerms-Service',
    '/executiveSignin',
    '/executiveSignup',
    '/executiveSignup/:executiveCode',
    '/excutive/dashboard',
    '/executiveT&S',
    '/merchantT&S',
    '/UserT&S',
    '/excutive/referal',
    '/excutive/hierarchy',
    '/executiveUpdate/:id',
    '/merchantForgotPassword',
    '/api/User/ResetPassword',
    "/userForgotPassword",
    '/api/Userdetails/ResetPassword',
    '/executiveForgotPassword',
    '/api/BDExecutive/reset-password',
    '/MerchantAccountDetails',
    '/select/slot',
    '/premiumCoupon/approval',
  ];

  // Hide layout if current path does not match any static route
  const hideLayout = !staticRoutes.some(route => {
    // Replace :params with regex to match dynamic paths
    const pattern = new RegExp('^' + route.replace(/:\w+/g, '[^/]+') + '$');
    return pattern.test(location.pathname);
  });

  return (
    <>
      {!hideLayout && <Header />}
      {!hideLayout && <ScrollToTop />}
      {!hideLayout && <Gotop />}
      {!hideLayout && <WhatsApp />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/top-coupons" element={<TopCoupons />} />
        <Route path="/best-offers" element={<BestOffers />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/terms-service" element={<TermsService />} />
        <Route path="/UserT&S" element={<UserTremsOfServices />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/admin-dashboard" element={<AdminDashBoard />} />
        <Route path="/user/dashboard" element={<UserDashboard />} />
        <Route path="/merchant/dashboard" element={<Dashboard />} />
        <Route path="/popular" element={<Popularity1 />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment/:amount/:mobile" element={<UserPayment />} />
        <Route path="/payment/:amount" element={<UserProductPayment />} />
        <Route path="/:id" element={<HomeRefaral />} />
        <Route path="/merchantproductsite/:merchantid" element={<MerchantSite />} />
        <Route path="/merchantpage" element={<MerchantPage />} />
        <Route path="/ownesite" element={<OwnesiteUrl />} />
        <Route path="/permission" element={<Permission />} />
        <Route path="/merchantRegistration" element={<MerchantRegistration />} />
        <Route path="/userRegistration" element={<UserRegistration />} />
        <Route path='/merchant/refer' element={<MerchantRefaral />} />
        <Route path='/MerchantSignup' element={<MerchantSignup />} />
        <Route path='/MerchantSignup/:id' element={<MerchantSignup />} />
        <Route path='/MerchantSignin' element={<MerchantSignin />} />
        <Route path='/userSignup' element={<UserSignUp />} />
        <Route path='/userSignup/:id' element={<UserSignUp />} />
        <Route path='/UserSignin' element={<UserSignIn />} />
        <Route path='/merchantterms-service' element={<MerchantTermsOfServices />} />
        <Route path='/merchantT&S' element={<MerchantTandS />} />
        <Route path='/executiveTerms-Service' element={<ExecutiveTermsOfServices />} />
        <Route path='/executiveT&S' element={<ExecutiveTandS />} />
        <Route path='/executiveSignin' element={<ExecutiveLogin />} />
        <Route path='/executiveForgotPassword' element={<ExecutiveForgotPassword />} />
        <Route path='/api/BDExecutive/reset-password' element={<ExecutiveResetPassword />} />
        <Route path='/executiveSignup' element={<ExecutiveRegistration />} />
        <Route path='/executiveSignup/:executiveCode' element={<ExecutiveRegistration />} />
        <Route path='/executiveUpdate/:id' element={<ExecutiveRegistrationUpdate />} />
        <Route path='/merchantForgotPassword' element={<MerchantForgotPassword/>}/>
        <Route path='/api/User/ResetPassword' element={<MerchantResetPassword/>}/>
        <Route path='/userForgotPassword' element={<UserForgotPassword/>}/>
        <Route path='/api/User/ResetPassword' element={<MerchantResetPassword/>}/>
        <Route path='/api/Userdetails/ResetPassword' element={<UserResetPassword/>}/>
        <Route path='/MerchantAccountDetails' element={<MerchantAccountDetails/>}/>
        <Route path='/select/slot' element={<SelectSlot/>}/>
        <Route path='/premiumCoupon/approval' element={<PremiumCouponApproval/>}/>

        <Route path='' element={<ExecutiveDashboardOne />}>
          <Route path='/excutive/hierarchy' element={<ExecutiveHierarchy />} />
          <Route path='/excutive/referal' element={<ExcutiveReferal />} />
          <Route path='/excutive/dashboard' element={<ExcutiveProfile />} />
        </Route>


        <Route />
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
}

export default App;

